<template>
  <figure class="card cursor" @click="play">
        <div class="img" :style="{backgroundImage: 'url(' + resource.图片地址 + ')'}"></div>
    <div class="lesson-detail">
        <h4>{{ resource.课件标题 }}</h4>
    </div>
    <div class="lesson-desc"><span>{{ resource.章节名称 }}</span></div>
  </figure>
</template>

<script>
export default {
  name: '',
  props: ['resource'],
  data () {
    return {

    }
  },
  components: {},
  created () {},
  mounted () {
    
  },
  methods: {
    play(){
      this.$emit('resource_play',this.resource)
    }
  }
}
</script>

<style lang="less" scoped>
.card{
    display: flex;
    margin-bottom: 30px;
    width: 270px;
    height: 225px;
    border-radius: 4px;
    overflow: hidden;
    transition: all .3s;
    border: 1px solid #e8eff5;
    float: left;
    margin-right: 20px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-transition: all .3s;
    line-height: 1.5;
    
    .img{
        height: 151px;
        background-size: contain;
        background-repeat: no-repeat;
    }
    .lesson-detail{
      flex: 1;
      h4{
        display: -webkit-box;
        -webkit-line-clamp: 2; 
        -webkit-box-orient: vertical; 
        overflow: hidden;
        text-overflow: ellipsis; 
        width: 100%;
        font-size: 13px;
        color: rgba(0, 0, 0, .85);
        font-weight: 500;
        font-family: MicrosoftYaHei;
        padding: 10px 14px 0;
      }
      
    }
}
.lesson-desc{
        display: flex;
        font-size: 13px;
        color: #b3b3b3;
        -webkit-box-pack: justify;
        justify-content: space-between;
        padding: 2px 14px;
      }
.card:nth-child(4n){
      margin-right: 0;
    }
.cursor{
    cursor: pointer;
    user-select: none;
}
.card:hover {
    transform: translateY(-5px); 
    box-shadow: 0 8px 5px 0 #f1f0f0; /* 只在底部出现阴影，且不散射 */
}
@media screen and (max-width: 1440px) and (min-width: 1140px) {
  .card{
        width: 270px;
    }
    
}
@media screen and (max-width: 1140px) and (min-width: 960px) {
  .card{
        width: 197.5px;
        height: 185px;
        .img{
          height: 115px; 
        }
    }
}
@media screen and (max-width: 960px) and (min-width: 576px) {
  .card{
        width: 125px;
        height: 145px;
        .img{
          height: 75px; 
        }
        .lesson-desc span{
          overflow: hidden;
          text-overflow: ellipsis; 
          white-space: nowrap; 
        }
    }
}
@media screen and (max-width: 576px) and (min-width: 450px) {
  .card{
        width: 84px;
        height: 120px;
        .img{
          height: 75px; 
        }
        .lesson-desc span{
          overflow: hidden;
          text-overflow: ellipsis; 
          white-space: nowrap; 
        }
    }
}
@media screen and (max-width: 450px) {
  .card{
        width: 49%;
        height: 185px;
        margin-right: 2%;
        .img{
          height: 15vh; 
        }
        .lesson-desc span{
          overflow: hidden;
          text-overflow: ellipsis; 
          white-space: nowrap; 
        }
        .lesson-detail h4{
          padding: 0 14px;
          font-size: 3.5vw;
        }
    }
    .card:nth-child(2n){
      margin-right: 0;
    }
}
</style>
